import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { ProductFiltersModule } from "src/app/ui-widgets/product-filters/product-filters.module";
import { ProductPaginationModule } from "src/app/ui-widgets/product-pagination/product-pagination.module";
import { ProductReviewsModule } from "src/app/ui-widgets/product-reviews/product-reviews.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { ShoeInsolesComponent } from "./shoe-insoles.component";
import { ShoeInsolesRoutingModule } from "./shoe-insoles-routing-module";
import { FormsModule } from "@angular/forms";

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        HeaderModule,
        SidebarModule,
        ShoeInsolesRoutingModule
    ],
    declarations: [
        ShoeInsolesComponent
    ]
})
  export class ShoeInsolesModule { }
